import React, { Component, PureComponent } from 'react';
import {
	Collapse,
	Container,
	Button,
	Navbar,
	NavbarToggler,
	NavbarBrand,
	Nav,
	NavItem,
	NavLink,
	UncontrolledDropdown,
	DropdownMenu,
	DropdownItem } from 'reactstrap';
import { A, BlessLink, R } from './routes';

import Butt from './c/Butt';
import Bubble from './c/Bubble';
import Footer from './c/Footer';
import { SignupLoginModal } from './c/SignupLogin';
import BeforeWeLetYouIn from './c/BeforeWeLetYouIn';
import { connect } from 'react-redux';
import './NotificationsService';
import { TradeModal } from './c/Trade';
import { T, TraksConsumer } from './traks';
import SearchField from './c/SearchField';
import {
	ModalContainer,
	ModalContainerContent,
} from './Modal';
import store from './store';
import API from './API';
import { AUAContainer } from './AUA';
import { TickerTape } from './c/TickerTape';
import { is_app } from './App';
import OurLogo from './c/OurLogo';
import { AdminActionsModal } from './c/AdminActionsModal';
import { GroupGameModal } from './c/GroupGameModal';
import { SplitV2ErrorModal } from './c/SplitV2ErrorModal';
import { SplitV2FallbackApplyModal } from './c/SplitV2FallbackApplyModal';
import { canViewReportNavigation } from './GameConfig';

const G = (props) => props.children;

class DynamicSpacer extends Component {
	constructor(props) {
		super(props);
		this.anim_frame = null;
		this.state = {spacing: 0};
	}

	componentWillUnmount() {
		if (this.anim_frame !== null) {
			window.cancelAnimationFrame(this.anim_frame);
			this.anim_frame = null;
		}
	}

	render() {
		var rq; rq = () => {
			if (this.anim_frame !== null) window.cancelAnimationFrame(this.anim_frame);
			this.anim_frame = window.requestAnimationFrame(() => {
				this.anim_frame = null;
				const em = document.getElementById(this.props.element_id);
				if (em) {
					const bbox = em.getBoundingClientRect();
					const height = bbox.bottom - bbox.top;
					this.setState({spacing: height});
				}
				rq();
			});
		}
		rq();
		return <div style={{paddingTop: this.state.spacing}}/>;
	}
}

function ActionNavLink(props) {
	const pass_props = {...props};
	delete pass_props.on_action;
	delete pass_props.children;
	const click = (e) => {
		props.on_action();
	};
	return <span onClick={click} onKeyDown={click}><BlessLink><NavLink {...pass_props}>{props.children}</NavLink></BlessLink></span>;
}

class Topbar extends PureComponent {
	constructor(props) {
		super(props);
		this.state = {is_open: false};
	}

    getMenuLogo() {
        let imageUrl = 'https://aktiedysten-static-v2.s3.eu-north-1.amazonaws.com/gfx';

        if (IS_BT) {
            return `${imageUrl}/bt-profile.svg`;
        } else if (IS_EUROINVESTOR) {
            return `${imageUrl}/euroinvestor-profile.svg`;
        } else {
            return `${imageUrl}/berlingske-profile.svg`
        }
    }

	logout() {
		R.replace("/logout");
	}

	render_navbar_items_logged_in(close) {
		const logout = (e) => {
			close();
			this.logout();
		};
        
		return (
			<G>
				<NavItem className="d-md-none">
					<ActionNavLink on_action={close} href="/trade_history">
						<span className="ad_navbar_textlink"><T>Trade history</T></span>
					</ActionNavLink>
				</NavItem>
				<NavItem className="d-md-none">
					<ActionNavLink on_action={close} href="/preferences">
						<span className="ad_navbar_textlink"><T>Preferences</T></span>
					</ActionNavLink>
                    {canViewReportNavigation(this.props.me) && (
                        <ActionNavLink on_action={close} href="/user_reports">
						    <span className="ad_navbar_textlink"><T>User Reports</T></span>
					    </ActionNavLink>
                    )}
					{this.props.me && this.props.me.IsGod && (
						<NavItem className="d-md-none">
							<ActionNavLink on_action={close} href="/flagged_portfolios">
								<span className="ad_navbar_textlink">Flagged portfolios</span>
							</ActionNavLink>
						</NavItem>
					)}
				</NavItem>
				<NavItem>
					<ActionNavLink on_action={close} className="nav-link-parent py-2 py-md-0" href="/notifications">
						<div className="ad_navbar_textlink ad_notification_container">
							<span className="d-none d-md-block ad_home_summary_bottom_headline">
								<T>Notifications</T>
							</span>
							<div className="ad_notification_bubble">
								<Bubble value={this.props.unseen_notifications}/>
							</div>
							<span className="d-md-none"><T>Notifications</T></span>
						</div>
					</ActionNavLink>
				</NavItem>
				<NavItem className="d-md-none mt-auto">
					<ActionNavLink on_action={logout} href="/">
						<span className="ad_navbar_textlink"><T>Logout</T></span>
					</ActionNavLink>
				</NavItem>
			</G>
		)
	}

	render_home_nav_link(close) {
		return (
			<NavItem>
				<ActionNavLink on_action={close} className="nav-link-parent py-2 py-md-0 mr-md-3" href="/">
					<div className="ad_navbar_textlink ad_notification_container">
						<span className="d-none d-md-block ad_home_summary_bottom_headline">Forside</span>
						<span className="d-md-none">Forside</span>
					</div>
				</ActionNavLink>
			</NavItem>
		);
	}

	render_navbar_menu_logged_in() {
		const logout = (e) => {
			e.preventDefault();
			this.logout();
		};

        

		return (
			<G>
				<NavItem>
					<UncontrolledDropdown className="d-none d-md-block">
						<div class="dropdown nav ad_no_outline_focus nav-link-parent">
							<div className="ad_navbar_textlink ad_notification_container text-center">
								<img className="ad_margin_bottom_2px ad_sub_navbar_image" src={this.getMenuLogo()} />
								<span className="d-none d-md-block ad_home_summary_bottom_headline">
									Profil
								</span>
							</div>
						</div>
						<div tabindex="-1" role="menu" aria-hidden="true" className="dropdown-menu dropdown-menu-right">
							<BlessLink><DropdownItem className="p-3 ad_gray_fg" href="/trade_history"><T>Trade history</T></DropdownItem></BlessLink>
							<BlessLink><DropdownItem className="p-3 ad_gray_fg" href="/preferences"><T>Preferences</T></DropdownItem></BlessLink>
                            {canViewReportNavigation(this.props.me) && (
                                <BlessLink><DropdownItem className="p-3 ad_gray_fg" href="/user_reports"><T>User Reports</T></DropdownItem></BlessLink>
                            )}
							{this.props.me && (this.props.me.IsGod) && (
                                <BlessLink><DropdownItem className="p-3 ad_gray_fg" href="/flagged_portfolios">Flagged Portfolios</DropdownItem></BlessLink>
                            )}
							<DropdownItem className="p-3 ad_gray_fg" href="#" onClick={logout}><T>Logout</T></DropdownItem>
						</div>
					</UncontrolledDropdown>
				</NavItem>
			</G>
		);
	}

	render() {
		var toggler_classes = ["ad_no_outline_focus"];
		var bubble;
		if (!this.state.is_open) {
			toggler_classes.push("collapsed");
			bubble = (
				<div className="ad_burger_bubble">
					<Bubble value={this.props.unseen_notifications}/>
				</div>
			);
		}

		toggler_classes = toggler_classes.join(" ");

		/* subtlety: both can be false (props.me is intially false,
		 * then null if /a/whoami returns "not logged in")  */
		var is_logged_in = !!this.props.me;
		var not_logged_in = this.props.me === null;

		const toggle = () => {
			this.setState((prev_state) => {
                const is_open = !prev_state.is_open;

                // Add or remove 'overflow-hidden' on the body
                if (is_open) {
                    document.body.classList.add('overflow-hidden');
                } else {
                    document.body.classList.remove('overflow-hidden');
                }

                return { is_open };
            });
		};

		const close = () => {
			document.body.classList.remove('overflow-hidden');
			this.setState({is_open: false});
		};

		var nav_classes = "p-2 navbar-collapse-scrollable";

		if(is_app) {
			nav_classes += " ad_pt_30px";
		}

		const brand = <OurLogo sponsored={true}/>

		return (
			<div>
				<Navbar expand="md" dark fixed="top" className={`${toggler_classes} ${nav_classes}`} id="main_topbar">
					<Container className="p-md-0 flex-column flex-nowrap flex-md-row justify-content-md-end lign-items-baseline h-100">
						<div class="d-flex align-items-center justify-content-between w-100">
						<NavbarBrand className="ad_no_outline_focus ad_sponsored_brand_link" href="https://www.euroinvestor.dk" target="_blank" rel="noopener noreferrer" aria-label="Euroinvestor">
							{brand}
						</NavbarBrand>

						<div className="ad_burger_container d-flex flex-column d-md-none">
							<img className="ad_margin_bottom_2px ad_sub_navbar_image align-self-end" src={this.getMenuLogo()} />
							<NavbarToggler onClick={toggle} className={toggler_classes}/>
							{bubble}
						</div></div>
						<Collapse isOpen={this.state.is_open} navbar className="w-100 justify-content-md-end my-md-auto">
							<div class="collapse-content d-flex flex-column flex-md-row align-items-md-end gap-0 gap-md-20 h-100">
								<Nav navbar className="navbar-searchbar translate-middle">
									<NavItem>
										<SearchField form_classes="pt-3 pt-md-0 pb-2 pb-md-0" on_action={close} input_id="search_field_0"/>
									</NavItem>
								</Nav>
								<Nav navbar className="flex-fill">
									{ this.render_home_nav_link(close) }
									{ is_logged_in && this.render_navbar_items_logged_in(close) }
								</Nav>
								<Nav>
									{ is_logged_in && this.render_navbar_menu_logged_in() }
								</Nav>
							</div>
						</Collapse>
					</Container>
				</Navbar>
				<DynamicSpacer element_id="main_topbar"/>
				<TickerTape/>
			</div>
		);
	}
}

Topbar = connect(
	(state) => ({me: state.me, unseen_notifications: state.unseen_notifications})
)(Topbar);

class PleaseGiveUsYourEmailNagBoxInner extends Component {
	constructor(props) {
		super(props);
		this.state = {email: "", err: ""};
	}

	render() {
		const go_away = () => {
			store.dispatch_value("just_logged_in_with", null);
		};

		const change = (e) => {
			this.setState({[e.target.name]: e.target.value});
		};

		const { aua } = this.props;

		const can_submit = this.state.email.trim().length > 0;

		const validate_and_post = (e) => {
			e.preventDefault();
			aua.request.set_email_password(null, this.state.email, null, false, (err) => {
				var new_state = {err: ""}
				if (err) {
					new_state.err = err.code;
				} else {
					go_away();
				}
				this.setState(new_state);
			});
		};

		var has_email_input_error = false;
		var error_element;
		switch (this.state.err) {
		case "": break;
		case "email_conflict":
			error_element = <span><T>The email address is being used by another account</T></span>;
			has_email_input_error = true;
			break;
		case "email_invalid":
			error_element = <span><T>You must enter a valid email address</T></span>;
			has_email_input_error = true;
			break;
		default:
			error_element = <span>{this.state.err}</span>;
			break;
		}

		const errcls = (has_error, cls) => cls + (has_error ? " ad_input_error" : "");

		return (
			<div className="ad_email_nagging_box ad_email_nagging_box_placement">
				<div className="px-4 pt-3 ad_150pct ad_text_blackish pb-2"><b><T>We're missing your e-mail</T></b></div>
				<div className="px-4 ad_profile_gray pt-3">
				<T>We need your e-mail to send you updates about your games,
				platform enhancements, tips &amp; tricks and more.
				</T>
				</div>
				<div className="px-4 ad_profile_gray py-3">
				<T>You can always change you email settings <A className="ad_blue_link" href="/preferences">here</A>.</T>
				</div>
				<div className="px-4 ad_email_nag_input_txt ad_profile_gray"><T>E-MAIL ADDRESS:</T></div>
				<form onSubmit={validate_and_post}>
				<div className="px-4 py-2"><input type="email" name="email" value={this.state.email} onChange={change} className={errcls(has_email_input_error, "add_profile_gray form-control p-3")} />
				</div>
				{error_element && <div className="px-4 pb-4 errors">{error_element}</div>}
				<div className="px-4 pt-4 pb-2"><Button disabled={!can_submit} type="submit" className="ad_new_game_button w-100"><T>Add e-mail</T></Button></div>
				<div className="px-4 pb-4"><Button onClick={go_away} className="ad_no_thanks_button w-100"><T>No thanks!</T></Button></div>
				</form>
			</div>
		);
	}
}

const NagBox = (props) => {
	return (
		<div className="ad_email_nagging_box ad_email_nagging_box_placement">
			{props.children}
		</div>
	);
};


class VerifyEmailNagBoxInner extends Component {
	constructor(props) {
		super(props);
		const { aua } = props;
		this.state = {
			email: aua.me.LocalEmail,
			auth_password: "",
			err: "",
			cooldown: false,
		};
		this.timeout = undefined;
	}

	componentWillUnmount() {
		if (this.timeout !== undefined) {
			clearTimeout(this.timeout);
			this.timeout = undefined;
		}
	}

	render() {
		const { aua } = this.props;
		const { auth, me, lang } = aua;
		const trl = (x) => x.trim().toLowerCase();
		const is_different_email = trl(this.state.email) !== trl(me.LocalEmail);

		const compulsory_passwd_auth = auth === "passwd";

		const validate_and_post = (do_execute) => {
			if (do_execute) this.setState({cooldown: true});

			const dryrun = !do_execute;

			if (is_different_email) {
				aua.request.set_email_password(this.state.auth_password, this.state.email, null, dryrun, (err) => {
					var new_state = {err: "", cooldown: false};
					if (err) {
						new_state.err = err.code;
					} else {
						new_state.cooldown = true;
						this.timeout = setTimeout(() => {
							this.setState({cooldown: false});
						}, 12500);
					}
					this.setState(new_state);
				});
			} else {
				API.post("/a/resend_verification_email", {lang}, (response, status) => {
					this.timeout = setTimeout(() => {
						this.setState({cooldown: false});
					}, 12500);
				});
			}
		};

		const change = (e) => {
			this.setState({[e.target.name]: e.target.value});
		};

		const submit = (e) => {
			e.preventDefault();
			validate_and_post(true);
		};

		const errcls = (has_error, cls) => cls + (has_error ? " ad_input_error" : "");

		var has_email_input_error = false;
		var has_auth_password_input_error = false;
		var error_element;
		switch (this.state.err) {
		case "": break;
		case "auth_error":
			error_element = <span><T>Wrong password</T></span>;
			has_auth_password_input_error = true;
			break;
		case "email_conflict":
			error_element = <span><T>The email address is being used by another account</T></span>;
			has_email_input_error = true;
			break;
		case "email_invalid":
			error_element = <span><T>You must enter a valid email address</T></span>;
			has_email_input_error = true;
			break;
		default:
			error_element = <span>{this.state.err}</span>;
			break;
		}

		const email_is_login = me.HasPassword;

		const input_title = email_is_login ? <span><T>LOGIN / EMAIL:</T></span> : <span><T>EMAIL</T></span>;

		const require_password = compulsory_passwd_auth && is_different_email;

		var current_password_element;
		if (require_password) {
			current_password_element = (
				<div className="px-4 py-2 mb-3">
					<div className="ad_email_nag_input_txt ad_profile_gray">
						<T>Enter your current password to change your email:</T>
					</div>
					<input
						className={errcls(has_auth_password_input_error, "form-control p-3")}
						type="password"
						name="auth_password"
						disabled={this.state.cooldown}
						value={this.state.auth_password}
						onChange={change}
					/>
				</div>
			);
		}

		const can_submit = !require_password || this.state.auth_password.length > 0;

		const But = (props) => <Button type="submit" className="ad_new_game_button w-100" disabled={this.state.cooldown || !can_submit}>{props.children}</Button>;

		const clicky = is_different_email
			? (<But><T>Change login/email and send email</T></But>)
			: (<But><T>Resend email</T></But>);

		const current_email = me.LocalEmail;

		const explanation = email_is_login
			? <T>It contains a link you must click in order to keep your account active.</T>
			: <T>It contains a link you must click to verify your email.</T>

		return (
			<NagBox>
				<div className="px-4 pt-4 ad_150pct ad_text_blackish pb-3"><b><T>Please verify your email</T></b></div>
				<div className="px-4 ad_profile_gray py-3">
				<T>We've sent you a verification email to <tt>{current_email}</tt>.</T>&nbsp;
				{explanation}
				</div>
				<div className="px-4 ad_email_nag_input_txt ad_profile_gray">{input_title}</div>
				<form onSubmit={submit}>
					<div className="px-4 py-2">
						<input
							disabled={this.state.cooldown}
							className={errcls(has_email_input_error, "form-control p-3")}
							type="email"
							name="email"
							onChange={change}
							value={this.state.email}
						/>
					</div>
					{current_password_element}
					{error_element && <div className="px-4 pb-4 errors">{error_element}</div>}
					<div className="px-4 pb-4">
						{clicky}
					</div>
				</form>
			</NagBox>
		);
	}
}

const VerifyEmailNagBox = (props) => <AUAContainer><VerifyEmailNagBoxInner {...props}/></AUAContainer>;
const PleaseGiveUsYourEmailNagBox = (props) => <AUAContainer><PleaseGiveUsYourEmailNagBoxInner {...props}/></AUAContainer>;

const PotentialNagBox = connect(
	(state) => ({
		me: state.me,
		has_unverified_email: state.has_unverified_email,
		just_logged_in_with: state.just_logged_in_with,
	})
)((props) => {
	if (!props.me) {
		return null;
	}

	return null;

	if ((props.just_logged_in_with === "fb" || props.just_logged_in_with === "twtr") && props.me && !props.me.LocalEmail && props.me.Epoch === 1) {
		return <PleaseGiveUsYourEmailNagBox/>;
	} else if (props.has_unverified_email) {
		return <VerifyEmailNagBox/>;
	} else {
		return null;
	}
});

const FFFFFFFFFFFFFFFFFFFFFFUU = connect(
	(state) => ({ me: state.me })
)((props) => {
	/* XXX This probably violates all good practices, even ones not
	 * invented yet. The problem I'm trying to solve is to display
	 * BeforeWeLetYouIn.Modal conditionally based on "me", and also what
	 * page I'm visiting; it's stuff like "we need to block access to the
	 * site until user has accepted our terms, UNLESS they're visiting the
	 * terms page, in which case it's silly to force the user to accept the
	 * terms before the user can read the terms". Things I've tried:
	 *
	 *  - since Redux is basically the master of both the user object
	 *    ("me") and the "modal stack", I thought I could solve it in
	 *    store.js, however, importing ./c/BeforeWeLetYouIn in store.js has
	 *    side-effects that breaks the site (and if I fixed that, I'd still
	 *    have to figure out which page I'm on)
	 *
	 *  - "BeforeWeLetYouIn" derives from the old RequireEmailModal which
	 *    was triggered in index.js. This almost works, except that
	 *    index.js is kind of a "bootloader", and only executes once. This
	 *    leads to sillyness where you can login without encountering the
	 *    modal, but after a refresh/revisit you see it...
	 *
	 *  - The same as here, but without setTimeout(..., 0); React complains
	 *    about state-changes occuring in the render method ("Warning:
	 *    Cannot update during an existing state transition (such as within
	 *    `render`). Render methods should be a pure function of props and
	 *    state.")
	 *
	 * I'm sure the REAL problem is that I haven't seen Martin Fowler's
	 * latest webinar about the Show-Modal-In-React pattern that "fixes
	 * everything", and not THAT I'M WRITING CODE ON TOP OF 20 MILLION
	 * LINES OF BROWSER CODE, AND ALSO 300k LINES OF REACT CODE WHICH ONLY
	 * EXISTS TO FIX PROBLEMS WITH THE OTHER 20 MILLION LINES OF CODE.
	 */
	if (props.allow_nagbox) {
		setTimeout(() => {
			BeforeWeLetYouIn.open_if_required(props.me)
		}, 0);
	}
	return null; // we're not here to render, bro!
});

const MainImpl = (props) => {
	return (
		<ModalContainer>
			<ModalContainerContent>
				<Topbar/>
				<main role="main" className="container-fluid p-0">
					{props.child}
				</main>
				<Footer/>
				{props.allow_nagbox && <PotentialNagBox/>}
				<FFFFFFFFFFFFFFFFFFFFFFUU allow_nagbox={props.allow_nagbox}/>
			</ModalContainerContent>
			<TradeModal/>
			<SignupLoginModal/>
			<BeforeWeLetYouIn.Modal/>
			<AdminActionsModal />
            <GroupGameModal />
			<SplitV2ErrorModal />
			<SplitV2FallbackApplyModal />
		</ModalContainer>
	);
}

const Main = (props) => <MainImpl allow_nagbox={true} {...props}/>
const MainNoNagbox = (props) => <MainImpl allow_nagbox={false} {...props}/>

export {
	Main,
	MainNoNagbox,
}



// WEBPACK FOOTER //
// ./src/Main.js